/**
 * M75/M95/M97 Chapter 2 map assignment — progressive topology ladder.
 * Multi-route maps are gated to ordinals reference bots clear with earned Research.
 */

/** Explicit production-map overrides / ladder (ordinal → mapId). */
export const CHAPTER2_MAP_OVERRIDES: Partial<Record<number, string>> = {
  1: 'valley-v',
  2: 'valley-v',
  3: 'crossroads-c',
  4: 'switchback-s',
  5: 'crossroads-c',
  6: 'valley-v',
  7: 'switchback-s',
  8: 'crossroads-c',
  9: 'valley-v',
  10: 'confluence',
  11: 'twinspire',
  12: 'valley-v',
  13: 'crossroads-c',
  14: 'twinspire',
  15: 'valley-v',
  16: 'twinspire',
  17: 'crossroads-c',
  18: 'valley-v',
  19: 'twinspire',
  20: 'crossroads-c',
  21: 'valley-v',
  22: 'valley-v',
  23: 'switchback-s',
  24: 'twinspire',
  25: 'switchback-s',
  26: 'valley-v',
  27: 'valley-v',
  28: 'crossroads-c',
  29: 'twinspire',
  30: 'crossroads-c'
}

export const CHAPTER2_MAP_FOR_ORDINAL: Record<number, string> = Object.fromEntries(
  Array.from({ length: 30 }, (_, i) => {
    const n = i + 1
    return [n, CHAPTER2_MAP_OVERRIDES[n] ?? 'valley-v']
  })
) as Record<number, string>

export function chapter2MapForOrdinal(ordinal: number, fallback: string): string {
  return CHAPTER2_MAP_OVERRIDES[ordinal] ?? fallback
}

/** Resolve Stage 2 map id for an ordinal (M95/M97 ladder). */
export function chapter2MapId(ordinal: number): string {
  return CHAPTER2_MAP_FOR_ORDINAL[ordinal] ?? 'valley-v'
}
